import type { MessageDescriptor } from 'react-intl';
import type { ProfileTool } from '../profileRoute';
import { profileBioMessages } from '../bio/profileBioMessages';
import { profileToolMessages as t } from './profileToolMessages';

/** The title and the line under it of each tool (design b1–b4, c1). */
export const PROFILE_TOOL_TITLES: Readonly<Record<ProfileTool, { name: MessageDescriptor; sub: MessageDescriptor }>> = {
  spotifyHeader: { name: t.headerName, sub: t.headerSub },
  spotifyAvatar: { name: t.avatarName, sub: t.avatarSub },
  banners: { name: t.bannersName, sub: t.bannersSub },
  pressPhoto: { name: t.pressName, sub: t.pressSub },
  bio: { name: profileBioMessages.name, sub: profileBioMessages.sub },
};
